import { render, staticRenderFns } from "./companyFinance.vue?vue&type=template&id=3675426b&"
import script from "./companyFinance.vue?vue&type=script&lang=js&"
export * from "./companyFinance.vue?vue&type=script&lang=js&"
import style0 from "./companyFinance.vue?vue&type=style&index=0&id=3675426b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports